import i18n from 'i18next';
import { useEffect, useState } from 'react';
import { getLADSortingFieldsListEffect } from '../../../redux/Claims/LossAndDamage/LossAndDamageClaimsEffects';
import FormSelectBox from '../Inputs/FormSelectBox';

const LADClaimsSortingSelector = ({
  placeholder = i18n.t('translation:default.fields.sortBy.select'),
  label = i18n.t('translation:default.fields.sortBy.label'),
  rules = [],
  name,
  editMode,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getStatusList();
  }, []);

  const getStatusList = async () => {
    try {
      setLoading(true);
      const { data } = await getLADSortingFieldsListEffect();
      const options = data.map((row) => ({
        label: row.value,
        value: row.key,
      }));
      setOptions(options);
      setLoading(false);
    } catch {
      setOptions([]);
      setLoading(false);
    }
  };

  return (
    <FormSelectBox
      loading={loading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin="mb-0"
      rules={rules}
      name={name}
      editMode={editMode}
    />
  );
};

export default LADClaimsSortingSelector;
